import moment from 'moment';
import { getTimeDetails } from './TimesheetDetails';
import { isAlwaysAvailable } from '../contracts/ContractPhase';
import { isNoQuantityAllowed } from './CrewTimesheet';

const isTimesheetContractPhaseValid = (
    timesheetContractPhase,
    contractPhases
) => {
    const contractPhase = contractPhases.find(
        (cp) => cp.id == timesheetContractPhase.contractPhaseId
    );

    if (!contractPhase) {
        console.error(
            `Could not locate a contract phase for TimesheetContractPhase ID ${timesheetContractPhase.id} / ContractPhaseId ${timesheetContractPhase.contractPhaseId}.`
        );

        return false;
    }

    if (
        isAlwaysAvailable(contractPhase) ||
        isNoQuantityAllowed(timesheetContractPhase)
    ) {
        return true;
    }

    if (timesheetContractPhase.notes) {
        return true;
    }

    return (
        timesheetContractPhase.quantity > 0 &&
        ((timesheetContractPhase.timesheetPhaseMaterials &&
            timesheetContractPhase.timesheetPhaseMaterials.every(
                (tpm) => tpm.quantity > 0
            )) ||
            (timesheetContractPhase.timesheetPhaseMaterialAdjustments &&
                timesheetContractPhase.timesheetPhaseMaterialAdjustments.every(
                    (tpma) => tpma.quantity > 0
                )))
    );
};

export const isTimesheetValid = (timesheet, job) => {
    const basicTimeSet = timesheet.startTime && timesheet.endTime;

    const adjustedTimeSet =
        timesheet.adjustedStartTime && timesheet.adjustedEndTime;

    if (
        !timesheet ||
        !timesheet.timesheetDetails ||
        (!basicTimeSet && !adjustedTimeSet)
    ) {
        return false;
    }

    let isValid = true;

    const contractPhases = job.contract.contractPhases;

    timesheet.timesheetDetails.forEach((td) => {
        if (td.removed || td.adjustedRemoved === true) {
            return;
        }

        if (basicTimeSet && moment(td.start).isAfter(td.end, 'minute')) {
            isValid = false;
        }

        if (
            adjustedTimeSet &&
            moment(td.adjustedStartTime).isAfter(td.adjustedEndTime, 'minute')
        ) {
            isValid = false;
        }

        const timeDetails = getTimeDetails(td);

        if (timeDetails.incomplete || timeDetails.warning) {
            isValid = false;
        }
    });

    isValid =
        isValid &&
        timesheet.timesheetContractPhases.every((tcp) =>
            isTimesheetContractPhaseValid(tcp, contractPhases)
        ) &&
        timesheet.timesheetContractPhaseAdjustments.every((tcpa) =>
            isTimesheetContractPhaseValid(tcpa, contractPhases)
        );

    return isValid;
};
